import { useState, useEffect } from 'react';

export default () => {
  const [selectedChildId, setSelectedChildId] = useState<string | null>(
    localStorage.getItem('bizkids_selected_child') || null
  );

  useEffect(() => {
    if (selectedChildId) {
      localStorage.setItem('bizkids_selected_child', selectedChildId);
    } else {
      localStorage.removeItem('bizkids_selected_child');
    }
  }, [selectedChildId]);

  return { selectedChildId, setSelectedChildId };
};